/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  FunctionalComponent,
  h,
} from '@stencil/core';
import { Typography } from '@peculiar/certificates-viewer';
import { getString } from '../../utils/l10n';
import { FortifyLogoFull } from './fortify_logo_full';

export interface FortifyLayoutProps {
  hideFooter?: boolean;
}

export const FortifyLayout: FunctionalComponent<FortifyLayoutProps> = (props, children) => {
  const { hideFooter } = props;

  return (
    <div class="layout">
      <main class="layout_main">
        {children}
      </main>
      <footer
        class="layout_footer"
        hidden={hideFooter}
      >
        <Typography
          variant="c2"
          class="layout_footer_text"
        >
          {getString('copyright')}
        </Typography>
        <a
          href="https://fortifyapp.com/"
          target="_blank"
          rel="noopener noreferrer"
          class="layout_footer_text"
        >
          <FortifyLogoFull />
        </a>
      </footer>
    </div>
  );
};
